module.exports = __webpack_public_path__ + "static/podcast-4cba45bcbfc32e9302808b1952dd0c5c.jpg";